<cq-tools-sidenav>
  <div ui-view class="main-app"></div>
</cq-tools-sidenav>
<cq-notification-overlay></cq-notification-overlay>
